import parent from '../path';

export default `${parent}/settings`;
